import $ from 'jquery';

export default class {
  constructor(el) {
    const p = this;
    p.$el = $(el);

    p.$el.on('mouseenter', function(event) {
      if(p.$el.hasClass('is-hidden')){
        return false;
      }
      event.preventDefault();
      var bbox = p.$el.get(0).getBoundingClientRect();
      $(`
        <div class="c-map-tooltip js-map-tooltip">
          <span class="c-map-tooltip__left">${p.$el.attr("data-tooltip-postcode")} -</span>
          <span class="c-map-tooltip__right">${p.$el.attr("data-tooltip-title")}</span>
        </div>
      `).appendTo("body")
        .css({
          top: $(window).scrollTop() + bbox.top,
          left: bbox.left + bbox.width/2,
        });
    });

    p.$el.on('mouseleave', function(event) {
      event.preventDefault();
      $(".js-map-tooltip").remove();
      /* Act on the event */
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/components/MapTooltip.js